import { isCustomerUser } from 'shared/helpers/matchers/checkUserType';

export const settleOuncesAccess = (user, access, poolAccounts) =>
  isCustomerUser(user.userType)
    ? poolAccounts && poolAccounts.length && access.requestSettlement.metalPool
    : access.requestSettlement.metalPool;
